export default {
  data() {
    return {
      clientId: null
    }
  },
  created() {
    this.onClientChange()
  },
  methods: {
    onClientChange() {
      const client = this.$store.state.client
      if (!client)
        this.$router.replace('/')
      else
        this.clientId = client.id
    }
  },
  watch: {
    clientId() {
      this.load()
    },
    '$store.state.client'() {
      this.onClientChange()
    }
  }
}
